// US States data with abbreviations, full names, and URL slugs
export const STATES = [
  { abbr: 'AL', name: 'Alabama', slug: 'alabama' },
  { abbr: 'AK', name: 'Alaska', slug: 'alaska' },
  { abbr: 'AZ', name: 'Arizona', slug: 'arizona' },
  { abbr: 'AR', name: 'Arkansas', slug: 'arkansas' },
  { abbr: 'CA', name: 'California', slug: 'california' },
  { abbr: 'CO', name: 'Colorado', slug: 'colorado' },
  { abbr: 'CT', name: 'Connecticut', slug: 'connecticut' },
  { abbr: 'DE', name: 'Delaware', slug: 'delaware' },
  { abbr: 'FL', name: 'Florida', slug: 'florida' },
  { abbr: 'GA', name: 'Georgia', slug: 'georgia' },
  { abbr: 'HI', name: 'Hawaii', slug: 'hawaii' },
  { abbr: 'ID', name: 'Idaho', slug: 'idaho' },
  { abbr: 'IL', name: 'Illinois', slug: 'illinois' },
  { abbr: 'IN', name: 'Indiana', slug: 'indiana' },
  { abbr: 'IA', name: 'Iowa', slug: 'iowa' },
  { abbr: 'KS', name: 'Kansas', slug: 'kansas' },
  { abbr: 'KY', name: 'Kentucky', slug: 'kentucky' },
  { abbr: 'LA', name: 'Louisiana', slug: 'louisiana' },
  { abbr: 'ME', name: 'Maine', slug: 'maine' },
  { abbr: 'MD', name: 'Maryland', slug: 'maryland' },
  { abbr: 'MA', name: 'Massachusetts', slug: 'massachusetts' },
  { abbr: 'MI', name: 'Michigan', slug: 'michigan' },
  { abbr: 'MN', name: 'Minnesota', slug: 'minnesota' },
  { abbr: 'MS', name: 'Mississippi', slug: 'mississippi' },
  { abbr: 'MO', name: 'Missouri', slug: 'missouri' },
  { abbr: 'MT', name: 'Montana', slug: 'montana' },
  { abbr: 'NE', name: 'Nebraska', slug: 'nebraska' },
  { abbr: 'NV', name: 'Nevada', slug: 'nevada' },
  { abbr: 'NH', name: 'New Hampshire', slug: 'new-hampshire' },
  { abbr: 'NJ', name: 'New Jersey', slug: 'new-jersey' },
  { abbr: 'NM', name: 'New Mexico', slug: 'new-mexico' },
  { abbr: 'NY', name: 'New York', slug: 'new-york' },
  { abbr: 'NC', name: 'North Carolina', slug: 'north-carolina' },
  { abbr: 'ND', name: 'North Dakota', slug: 'north-dakota' },
  { abbr: 'OH', name: 'Ohio', slug: 'ohio' },
  { abbr: 'OK', name: 'Oklahoma', slug: 'oklahoma' },
  { abbr: 'OR', name: 'Oregon', slug: 'oregon' },
  { abbr: 'PA', name: 'Pennsylvania', slug: 'pennsylvania' },
  { abbr: 'RI', name: 'Rhode Island', slug: 'rhode-island' },
  { abbr: 'SC', name: 'South Carolina', slug: 'south-carolina' },
  { abbr: 'SD', name: 'South Dakota', slug: 'south-dakota' },
  { abbr: 'TN', name: 'Tennessee', slug: 'tennessee' },
  { abbr: 'TX', name: 'Texas', slug: 'texas' },
  { abbr: 'UT', name: 'Utah', slug: 'utah' },
  { abbr: 'VT', name: 'Vermont', slug: 'vermont' },
  { abbr: 'VA', name: 'Virginia', slug: 'virginia' },
  { abbr: 'WA', name: 'Washington', slug: 'washington' },
  { abbr: 'WV', name: 'West Virginia', slug: 'west-virginia' },
  { abbr: 'WI', name: 'Wisconsin', slug: 'wisconsin' },
  { abbr: 'WY', name: 'Wyoming', slug: 'wyoming' },
  { abbr: 'DC', name: 'District of Columbia', slug: 'district-of-columbia' },
];

// Helper functions
export const getStateByAbbr = (abbr) => STATES.find(s => s.abbr === abbr);
export const getStateBySlug = (slug) => STATES.find(s => s.slug === slug);
export const getStateByName = (name) => STATES.find(s => s.name.toLowerCase() === name.toLowerCase());
export const getAbbrFromSlug = (slug) => getStateBySlug(slug)?.abbr;
export const getSlugFromAbbr = (abbr) => getStateByAbbr(abbr)?.slug;
export const getNameFromAbbr = (abbr) => getStateByAbbr(abbr)?.name;
export const getNameFromSlug = (slug) => getStateBySlug(slug)?.name;

// Get all state abbreviations (for dropdown filtering)
export const STATE_ABBRS = STATES.map(s => s.abbr);

// Get all slugs (for sitemap generation)
export const STATE_SLUGS = STATES.map(s => s.slug);

// City slug helpers
export const createCitySlug = (city, stateAbbr) => {
  const citySlug = city.toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim();
  return `${citySlug}-${stateAbbr.toLowerCase()}`;
};

export const parseCitySlug = (slug) => {
  // Extract state abbreviation from the end (last 2 chars after final hyphen)
  const parts = slug.split('-');
  if (parts.length < 2) return null;

  const stateAbbr = parts[parts.length - 1].toUpperCase();
  const stateData = getStateByAbbr(stateAbbr);
  if (!stateData) return null;

  // Reconstruct city name from remaining parts
  const cityParts = parts.slice(0, -1);
  const cityName = cityParts.map(p => p.charAt(0).toUpperCase() + p.slice(1)).join(' ');

  return {
    city: cityName,
    stateAbbr,
    stateName: stateData.name,
    stateSlug: stateData.slug,
  };
};

export default STATES;
